<template>
  <div class="cmpprange">
    <div class="cmpprange_content">
      <StudyRangesMain
        rangeTab="range"
        style="--clr-back: var(--cmpprange-clr-black); --padding-content: 1rem"
        :namespace="''"
        :canAISolve="false"
        :rangesMaximized="true"
        :hasCenterControls="true"
        :hasTableTile="true"
        :tableGroups="l_sol_dynamic.tableGroups"
        :eqBuckets="l_sol_dynamic.eqBuckets"
        :hero="l_sol_static.hero"
        :opponent="l_sol_static.opponent"
        :combos="l_sol_dynamic.combos"
        :catDraws="l_sol_static.catDraws"
        :catHands="l_sol_static.catHands"
        :catEqBuckets="l_sol_static.catEqBuckets"
        :catEqBucketsAdvanced="l_sol_static.catEqBucketsAdvanced"
        :solution_picked="$store.getters.sol_data_solution_picked"
        :street="$store.getters.sol_data_street"
        :viewProps="l_viewProps"
        :heroLeft="$store.getters.sol_view_viewProps.heroLeft"
        :filterCombos="$store.getters.sol_filter_combos"
        :filterEvCompare="$store.getters.sol_filter_ev_comparison"
        :filterCategories="$store.getters.sol_filter_categories"
        :evProps="$store.state.solutions.evProps"
        :grouping
        :handInfo
        :useHex
        :showBetsIn
        :bettingInfo
        :isPreflop
        :showFlopContent
        :mobile
        :hasBottom="false"
        :max1280
        :heroGroup="heroDetail.group"
        :opponentGroup="opponentDetail.group"
        :heroGroupId="heroDetail.group_id"
        :opponentGroupId="opponentDetail.group_id"
        :tableMouseover="$store.getters.sol_detail_tableMouseover"
        :heroGroupsIds="heroDetail.groups_ids"
        :opponentGroupsIds="opponentDetail.groups_ids"
        :heroHandsIds="heroDetail.hands_ids"
        :opponentHandsIds="opponentDetail.hands_ids"
        :filteredHeroHandsIds="$store.getters.sol_filter_playersHandsIds[0]"
        :filteredOpponentHandsIds="$store.getters.sol_filter_playersHandsIds[1]"
        :hasPremiumGameformat
        :gameformat
        :hSpot="overviewSpot"
        :hasFilterPills="true"
        :hasRangeControls="true"
        :hasShortcutBtn="false"
        :ccProps="l_ccProps"
        class="swp_cont"
        @eqchart:click="handleEqChartClick"
        @touchstart="swpHandleTouchStart"
        @touchmove="swpHandleTouchMove"
        @touchend="e => swpHandleTouchEnd(e)"
      >
        <template #center_top>
          <div
            class="gw_box f-center"
            style="
              height: 1.5rem;
              gap: 2px;
              padding: 0 0.375rem;
              --clr-box-back: var(--clr-black-2);
            "
          >
            <div>
              <router-link
                class="icon_btn csst csst_nm clr-white"
                target="_blank"
                style="padding: 0.325rem"
                :to="
                  links_getLink({
                    pathName: 'StudySolutions',
                    hasTmpBoard: true,
                    asRouterLink: true,
                    namespace: namespace,
                    customQuery: { soltab: 'strategy' },
                  })
                "
              >
                <i class="mdi mdi-school text-medium"></i>
                <div
                  class="csst_content tracrls_btn_tooltip text-nowrap clr-white text-medium"
                  style="bottom: 0; right: 0; transform: translate(0, 100%)"
                  v-html="$t('tooltips.study_spot')"
                ></div>
              </router-link>
            </div>
            <BtnOpenDetachedTrainerInfo
              class="clr-white icon_btn text-medium"
              style="padding: 0.325rem"
              :tooltip="$t('tooltips.expand_info')"
              :namespace="namespace"
              @click.stop
            />
          </div>
        </template>
      </StudyRangesMain>
    </div>
  </div>
</template>

<script>
import StudyRangesMain from '@/components/Study/StudyRangesMain'
import BtnOpenDetachedTrainerInfo from '@/components/SpecialBtns/BtnOpenDetachedTrainerInfo'

import links_mix from '@/mixins/links_mix'
import swipe_mix from '@/mixins/swipe_mix'

export default {
  name: 'StudyCompareRangeDialog',
  components: {
    StudyRangesMain,
    BtnOpenDetachedTrainerInfo,
  },
  mixins: [swipe_mix, links_mix],
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'study-compare-range-dialog')
    },
    handleEqChartClick() {
      this.$store.dispatch('router_set_dialogs', `chart-eq-dialog_namespace-${this.namespace}`)
    },
    computeSolData() {
      if (this.apiData) {
        this.$store.dispatch('sol_data_setSolProps', { apiData: this.apiData })
      }
    },

    // -----------
    swpUp(eventData, args) {
      const swKey = eventData.e.gw_raTable_swKey
      if (swKey) {
        this.$store.dispatch('switchers_set_next', { key: swKey, num: -1 })
      }
    },
    swpDown(eventData, args) {
      const swKey = eventData.e.gw_raTable_swKey
      if (swKey) {
        this.$store.dispatch('switchers_set_next', { key: swKey, num: 1 })
      }
    },
  },
  computed: {
    l_ccProps() {
      const stratab = this.$store.getters.sw_study_range_center === 'strategy'

      return {
        handsPinnedHero: this.handInfo ? [this.handInfo.hand] : null,
        hasTableTile: true,

        hasFilterSuitsItem: !stratab,
        hasHorizontalChartItem: stratab,
        hasHorizontalChart: stratab,

        hasHandStrengthItem: this.showFlopContent && stratab,
        hasHandStrength: this.showFlopContent && stratab,
        hasRangeCategoriesItem: this.showFlopContent && stratab,
        hasRangeCategories: this.showFlopContent && stratab,
        hasRangeCategoriesHands: this.showFlopContent && stratab,
        hasRangeCategoriesDraws: this.showFlopContent && stratab,

        hasRangesComparisonItem: !stratab,
        hasRangesComparison: !stratab,
        hasEqChartItem: this.showFlopContent && !stratab,
        hasEqChart: this.showFlopContent && !stratab,
      }
    },
    l_viewProps() {
      const heroShowProp = this.$store.getters.sw_range_content_hero.replace('swv_', '')
      const vv = this.$store.getters.sol_view_viewProps
      const res = {
        ...this.$store.getters.sol_view_viewProps,
        hero_showPropHands: heroShowProp,
        hero_showPropTable: heroShowProp,
        hero_valuePropTable: heroShowProp,
        hero_noValueTable: !this.$store.getters.showHandValue || heroShowProp === 'strategy',
        player_showPropHands: vv.player === '0' ? heroShowProp : vv.opponent_valuePropHands,
        hero_emptyTable: !this.showFlopContent
          ? ['eq', 'strategy_eq', 'eqr'].includes(heroShowProp)
          : false,
      }
      // console.log(res, this.$store.getters.sol_view_viewProps)
      return res
    },

    max1280() {
      return this.$store.getters.screen_max1280
    },
    l_sol_dynamic() {
      const res = {
        tableGroups: this.$store.getters.sol_data_tableGroups(),
        combos: this.$store.getters.sol_data_combos(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
    heroDetail() {
      return this.$store.getters.sol_detail_players[0]
    },
    opponentDetail() {
      return this.$store.getters.sol_detail_players[1]
    },
    l_sol_static() {
      const res = {
        solData: this.$store.getters.sol_data_solData(),
        catDraws: this.$store.getters.sol_data_catDraws(),
        catHands: this.$store.getters.sol_data_catHands(),
        catEqBuckets: this.$store.getters.sol_data_catEqBuckets(),
        catEqBucketsAdvanced: this.$store.getters.sol_data_catEqBucketsAdvanced(),
        players: this.$store.getters.sol_data_players(),
        // TODO rm after 3way rls
        hero: this.$store.getters.sol_data_players()[0],
        opponent: this.$store.getters.sol_data_players()[1],
      }
      return this.$store.getters.sol_data_updated ? res : res
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    gameformat() {
      return this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gameformat`]
    },
    solElite() {
      return this.$store.getters.sol_elite
    },
    isPreflop() {
      return this.overviewSpot?.street === 'preflop'
    },
    showFlopContent() {
      return !!this.overviewSpot.custom_solution_id || !this.isPreflop
    },
    hasPremiumGameformat() {
      if (this.solElite?.want_use) {
        const { subs } = this.$store.getters.user_info
        const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
        const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
        return !!(anyPremiumPurchased || anyElitePurchased)
      }
      return ['PREMIUM', 'ELITE'].some(i => this.gameformat?.subscription_tier === i)
    },
    handInfo() {
      return this.apiData?.hand_info
    },
    overviewSpot() {
      return (
        this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}trainer_overview_spot`] ||
        {}
      )
    },
    bettingInfo() {
      return {
        pot: this.overviewSpot.pot,
        showEvIn: this.$store.getters.show_ev_in,
        showEvIcmIn: this.$store.getters.show_ev_icm_in,
        evIcmConverters: this.l_sol_static.players.map(player => player?.tournament_evs_converter),
      }
    },
    apiData() {
      if (this.$route.name === 'PracticeTrainer') {
        let res = this.overviewSpot
        res = res?.api_practice || {}
        return res
      }
      return null
    },
    namespace() {
      return this.dialog.namespace || ''
    },
  },
  watch: {
    overviewSpot: {
      immediate: true,
      handler: 'computeSolData',
    },
  },
}
</script>

<style lang="scss" scoped>
.cmpprange {
  display: flex;
  flex-direction: column;
  --cmpprange-clr-black: var(--clr-black-1);
  width: 100vw;
  aspect-ratio: 16/7.4;
  max-height: calc(var(--vh-100) - 3rem);
  &_content {
    background: var(--cmpprange-clr-black);
    display: flex;
    flex: 1;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
  }
}

@media (max-width: 1023px) {
  .cmpprange {
    aspect-ratio: unset;
    height: calc(var(--vh-100) - 3rem);
  }
}
</style>
